import { Box, Dialog, DialogContent, DialogTitle, Grid2, Paper } from '@mui/material';
import React, { Suspense, useEffect, useMemo } from 'react';
import CustomAccordion from '../../../../components/ui/materialui/customAccordion';
import Tabla from '../../../../components/ui/materialui/tabla';
import { useForm } from 'react-hook-form';
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { useColumns } from '../utils/columns';
import { useComunMinvu } from '../hooks/useComunMinvu';
import { getListaMinvu } from '../service/servicesComunMINVU';
import { FilterList } from '@mui/icons-material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Conversiones from '../../../../utils/conversiones';

interface IProps {
    show: boolean;
    onHide: () => void;
    tipoArchivo: string;
}

interface IFilter {
    fechaDesde: string;
    fechaHasta: string;
}

export interface ListaMINVU {
    idArchivo: number;
    tipoBeneficio: string;
    estado: string;
    fechaGeneracion: Date;
    fechaEnvio: Date;
    nombreArchivo: string;
    descripcionEstado: string;
    descripcionTipoBeneficio: string;
}

const validationSchema = yup.object().shape({
    fechaDesde: yup.string().required('Campo es requerida'),
    fechaHasta: yup.string().required('Campo es requerida'),
});

const ModalListadoMinvu: React.FC<IProps> = ({ show, onHide, tipoArchivo }) => {

    const defaultValues = {
        fechaHasta: new Date().toISOString().split('T')[0],// Default to today
        fechaDesde: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().split('T')[0] // Default to 3 months ago
    }
    const {
        formState: { errors },
        control,
        handleSubmit,
        watch,
        reset
    } = useForm<IFilter>({
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues,
        mode: 'onBlur'
    })

    const { fechaDesde: fechaDesdeWatch, fechaHasta: fechaHastaWatch } = watch();

    const { getListMinvu, listadoMinvu } = useComunMinvu();

    const onSubmit = (data: IFilter) => {
        getListMinvu(data.fechaDesde ?? defaultValues.fechaDesde, data.fechaHasta ?? defaultValues.fechaHasta, tipoArchivo);
    }

    const renderizar = () => {
        getListMinvu(fechaDesdeWatch, fechaHastaWatch, tipoArchivo);
    }


    const { COLUMNS } = useColumns(renderizar, tipoArchivo);
    //eslint-disable-next-line
    const columns = useMemo(() => COLUMNS, [listadoMinvu]);

    useEffect(() => {
        reset(defaultValues);

        if (!show) return;

        getListMinvu(defaultValues.fechaDesde, defaultValues.fechaHasta, tipoArchivo);
        // eslint-disable-next-line
    }, [tipoArchivo, show]);

    return (
        <Dialog
            open={show}
            onClose={onHide}
            maxWidth="xl"
        >
            <DialogTitle>
                Listado MINVU
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={3}>
                                            <InputFecha
                                                name="fechaDesde"
                                                control={control}
                                                label="Fecha Desde"
                                                error={errors?.fechaDesde}
                                                fecha={Conversiones.parseLocalDate(fechaDesdeWatch ?? '')} // Convert string to Date object
                                            />
                                        </Grid2>
                                        <Grid2 size={3}>
                                            <InputFecha
                                                name="fechaHasta"
                                                control={control}
                                                label="Fecha Hasta"
                                                error={errors?.fechaHasta}
                                                fecha={Conversiones.parseLocalDate(fechaHastaWatch ?? '')}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                        <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                            Filtrar
                                        </MButton>
                                    </Grid2>
                                </form>
                            </CustomAccordion>
                            <Tabla
                                columns={columns}
                                data={listadoMinvu}
                            />
                            <Grid2 container justifyContent="flex-end" mt={2}>
                                <MButton variant="contained" onClick={onHide} >
                                    Volver
                                </MButton>
                            </Grid2>
                        </Suspense>
                    </Paper>
                </Box>
            </DialogContent>
        </Dialog >
    );
};

export default ModalListadoMinvu;